export const helpContentFr = {
  title: "Guide d'utilisation & Calculs",
  subtitle: "Documentation complète pour administrateurs",
  formulaLabel: "Formule",
  formula1Label: "Formule 1 - Durée journée",
  formula2Label: "Formule 2 - Heures de congé",
  examplesLabel: "Exemples par contrat",
  statusesLabel: "Statuts possibles",
  summaryTitle: "Récapitulatif des Formules",
  typeCol: "Type",
  formulaCol: "Formule",
  baseCol: "Base",
  workType: "Travail",
  leaveType: "Congés",
  sickType: "Maladie",
  recoveryType: "Récupération",
  slotBase: "Créneau planning",
  contractBase: "Heures contractuelles",
  reportBase: "Rapport hebdomadaire"
};

export const helpSectionsFr = {
  workHours: {
    title: "Calcul des Heures de Travail",
    desc: "Les heures de travail sont calculées à partir des créneaux du planning.",
    formula: "Heures = (Heure fin - Heure début) - Pause",
    example: "Ex: 08:00 → 17:00 avec 30 min pause = 9h - 0.5h = 8.5 heures",
    details: [
      "Les heures sont calculées par créneau (schedule_slots)",
      "La pause est déduite automatiquement",
      "Le système distingue heures planifiées et heures réelles",
      "Les heures réelles peuvent être modifiées via le rapport hebdomadaire"
    ]
  },
  leave: {
    title: "Calcul des Congés Payés",
    desc: "Les congés sont calculés en fonction des heures contractuelles de chaque collaborateur.",
    formula: "Durée jour = Heures contractuelles / 5 jours",
    formula2: "Heures congé = Nombre de jours × Durée jour",
    example: "Ex: Collaborateur à 40h/sem → 8h/jour. Congé de 3 jours = 24 heures",
    priority: "Priorité de déduction : Les congés sont d'abord déduits du solde N-1 (année précédente), puis du solde de l'année en cours."
  },
  sick: {
    title: "Calcul des Absences Maladie",
    desc: "Les absences maladie utilisent le même calcul que les congés.",
    formula: "Heures maladie = Nombre de jours × (Heures contractuelles / 5)",
    note: "Les absences maladie sont comptabilisées séparément et n'affectent PAS le solde de congés."
  },
  recovery: {
    title: "Heures Supplémentaires / Récupération",
    desc: "Les heures supplémentaires sont calculées via le rapport hebdomadaire.",
    formula: "Différence = Heures réelles - Heures planifiées",
    example: "Ex: Planifié 40h, Travaillé 42h → +2h de récupération potentielle",
    note: "Le système enregistre les différences mais ne gère pas encore un solde cumulé de récupération."
  },
  planning: {
    title: "Planning",
    items: [
      "Cliquez sur une cellule vide pour créer un créneau",
      "Glissez-déposez pour déplacer un créneau",
      "Redimensionnez en tirant les bords d'un créneau",
      "Utilisez 'Copier la semaine' pour dupliquer le planning",
      "Exportez en PDF ou Excel via les boutons dédiés"
    ]
  },
  planningTotals: {
    title: "Calcul des Totaux dans le Planning",
    desc: "Les tableaux de totaux affichent les heures des collaborateurs présents sur le planning selon la vue sélectionnée.",
    views: [
      {
        name: "Vue Semaine (verticale)",
        items: [
          "Total Semaine : Affiche les collaborateurs présents sur la semaine sélectionnée avec leurs heures de cette semaine",
          "Total Mois : Affiche les collaborateurs présents sur le mois en cours avec leurs heures du mois"
        ]
      },
      {
        name: "Vue Mois (verticale)",
        items: [
          "Total Mois : Affiche les collaborateurs présents sur le mois affiché avec leurs heures du mois",
          "Le calcul est identique à celui de la vue semaine pour le total mois"
        ]
      },
      {
        name: "Vue Horizontale",
        items: [
          "Total Semaine : Affiche les collaborateurs présents sur la semaine de la première ligne visible",
          "Total Mois : Affiche les collaborateurs présents sur le mois en cours avec leurs heures du mois"
        ]
      }
    ],
    note: "Les totaux sont automatiquement filtrés selon les collaborateurs sélectionnés dans le filtre."
  },
  admin: {
    title: "Administration",
    items: [
      "Gérez les utilisateurs et leurs rôles",
      "Configurez les heures de travail par défaut",
      "Définissez les jours fériés",
      "Sauvegardez et restaurez les données (Backup)"
    ]
  },
  dailyValidation: {
    title: "Validation Quotidienne du Planning",
    desc: "Chaque collaborateur doit valider quotidiennement son planning via le tableau de bord.",
    items: [
      "Le bloc 'Valider mon planning' affiche tous les jours travaillés non validés",
      "Colonnes : Date, Heure début, Heure fin, Pause, Temps effectif",
      "Si conforme : cliquez sur ✅ pour valider directement",
      "Si non conforme : cliquez sur ✏️ pour proposer une modification (début/fin/pause) avec motif obligatoire",
      "Le bouton 'Valider tout' permet de confirmer tous les créneaux conformes en une seule action",
      "Les modifications sont soumises aux managers/directeurs pour approbation",
      "Le planning et les calculs d'heures ne sont modifiés qu'après validation par un manager/directeur",
      "L'historique affiche les demandes de modification avec leur statut : 🟢 approuvé ou 🔴 rejeté"
    ]
  },
  managerValidation: {
    title: "Interface Manager/Directeur - Validation des Plannings",
    desc: "Les managers et directeurs valident les modifications de planning soumises par les collaborateurs.",
    items: [
      "En haut de page : alerte pour les collaborateurs avec plus de 2 jours à valider",
      "Filtre 'État' : À valider (défaut), Modifié, Non modifié",
      "Filtre 'Collaborateurs' : Tous (défaut) ou sélection multiple",
      "Filtre 'Date' : Tout (défaut) ou plage de dates",
      "Chaque entrée affiche 3 lignes : planning original, modification proposée, et motif",
      "✅ Approuver : applique la modification au planning",
      "❌ Rejeter : refuse la modification",
      "Un marqueur visuel apparaît sur les créneaux modifiés dans le planning"
    ]
  }
};

export const leaveExamples = [
  { hours: "40h/semaine", day: "8h/jour", halfDay: "4h" },
  { hours: "42.5h/semaine", day: "8.5h/jour", halfDay: "4.25h" },
  { hours: "20h/semaine", day: "4h/jour", halfDay: "2h" },
  { hours: "17h/semaine", day: "3.4h/jour", halfDay: "1.7h" }
];

export const sickStatuses = [
  { status: "En attente", desc: "Demande en attente de validation" },
  { status: "Approuvée", desc: "Validée, affichée sur le planning" },
  { status: "Refusée", desc: "Non validée par le manager" },
  { status: "Annulée", desc: "Annulée par le collaborateur" }
];
